export default __webpack_public_path__ + "assets/not-available.28474c0c.svg";